
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/details/update",
      function () {
        return require("private-next-pages/account/details/update/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/details/update"])
      });
    }
  